







































import { Vue, Component, Prop } from 'vue-property-decorator';
import axios from 'axios';

import Container from './Registration/Container.vue';
import RegistrationCard from './Registration/Card.vue';
import CardHeader from './Registration/Header.vue';
import { vxm } from '../store.vuex';
import { ForgotPasswordRequest } from '../models/userdata/forgotpasswordreqeust';

import router from '../router';
@Component({
  components: {
    Container,
    RegistrationCard,
    CardHeader,
  },
})
export default class ForgotPassword extends Vue {
  @Prop({ default: '' }) email;
  private request: ForgotPasswordRequest = new ForgotPasswordRequest();
  private showSumbitButton: boolean = true;
  private emailRegex: RegExp = new RegExp(
    /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
  );
  private errors = {
    userEmail: '',
  };
  $wlToastr: any;
  mounted() {
    this.request.userEmail = this.email || '';
  }
  async onSubmit() {
    this.errors.userEmail = '';
    this.request.companyCode = vxm.jobs.BrandingInfo.companycode;
    if (!this.emailRegex.test(this.request.userEmail)) {
      this.errors.userEmail = 'forgotpassword.enter.valid.email';
    } else if (this.request.userEmail === '') {
      this.errors.userEmail = 'forgotpassword.email.required';
    } else {
      const bearerToken = 'Bearer ' + vxm.users.getToken;
      const resp = await axios.post(
        '/wl-profile-svc/api/user-profile/forgotPassword',
        this.request,
        {
          headers: {
            Authorization: bearerToken,
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
        },
      );
      if (resp.data.success) {
        this.$wlToastr(
          'success',
          this.$t('changepassword.success.message'),
          'Forgot Password',
        );
        router.push('login');
      } else {
        if (
          resp.data.errorMessage ===
          this.$t('forgotpassword.socialmedia.errormessage')
        ) {
          this.showSumbitButton = false;
        }
        this.errors.userEmail = resp.data.errorMessage;
      }
    }
  }
}
